import { useTranslation } from 'react-i18next';

import { Chevron } from './components/icons';
import styles from './ParentLinkHeader.module.css';

export interface ParentLinkHeaderProps {
  articleType?: string | null;
  breadcrumb: {
    name: string;
    url: string;
  };
  displayTitle?: string;
  title?: string;
}

export const ParentLinkHeader = ({
  articleType = null,
  breadcrumb,
  displayTitle,
  title,
}: ParentLinkHeaderProps): React.JSX.Element => {
  const { t } = useTranslation();

  let prefixLabel = '';

  if (articleType?.includes('picks')) {
    prefixLabel = 'CX_TIPS_HEADER_PREFIX';
  } else if (articleType?.includes('insights')) {
    prefixLabel = 'CX_NEWS_HEADER_PREFIX';
  } else if (articleType?.includes('betting-guide')) {
    prefixLabel = 'CX_BETTING_GUIDES_HEADER_PREFIX';
  }

  const prefix = prefixLabel ? t(prefixLabel) : '';

  const baseTitle = displayTitle || title;
  const renderedTitle = prefix && prefix !== prefixLabel ? `${prefix} ${baseTitle}` : baseTitle;

  const renderParentLinkHeaderContent = () => {
    return (
      <div className={styles.cardHeaderContentContainer}>
        <div className={`${styles.cardHeaderTextWrapper} ogm-card-header__title`}>
          <h1 className={styles.cardTitle} data-testid="card-title">
            {renderedTitle}
          </h1>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.cardHeaderWrapper} data-testid="card-header">
      <div className={styles.cardHeaderInnerWrapper} data-testid="card-breadcrumb-div">
        {!!breadcrumb && (
          <div className={styles.cardEventLinkWrapper}>
            <span className={styles.breadcrumbIcon}>{<Chevron />}</span>
            <a
              className={`${styles.cardEventLink} ogm-card-header__breadcrumb`}
              data-testid="card-breadcrumb"
              href={breadcrumb.url}
              title={breadcrumb.name}
            >
              {breadcrumb.name}
            </a>
          </div>
        )}
        <div className={styles.cardBodyWrapper} id="card-header">
          {renderParentLinkHeaderContent()}
        </div>
      </div>
    </div>
  );
};
